// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { PartFinderState } from "@store/Framework/Store/Store/Data/PartFinder/PartFinderState";
import { PartModel, PartsListModel, SkuModel } from "@store/Framework/Types/ApiModels";
import { Draft } from "immer";

const initialState: PartFinderState = {
    skus: [],
};

const actions = {
    "Store/Data/PartFinder/ResetSkus": () => {
        return initialState;
    },
    "Store/Data/PartFinder/BeginLoadSkus": () => {},
    "Store/Data/PartFinder/CompleteLoadSkus": (draft: Draft<PartFinderState>, action: { result: SkuModel[] }) => {
        draft.skus = action.result;
    },
    "Store/Data/PartFinder/BeginLoadPartsData": () => {},
    "Store/Data/PartFinder/BeginLoadReplacementsData": () => {},
    "Store/Data/PartFinder/CompleteLoadPartsData": (
        draft: Draft<PartFinderState>,
        action: { result: PartsListModel },
    ) => {
        draft.parts = action.result;
    },
    "Store/Data/PartFinder/CompleteLoadReplacementsData": (
        draft: Draft<PartFinderState>,
        action: { result: PartModel[] },
    ) => {
        draft.replacements = action.result;
    },
    "Store/Data/PartFinder/CompleteLoadModels": (draft: Draft<PartFinderState>, action: { result: string[] }) => {
        draft.models = action.result;
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type StorePartFinderActions = Parameters<typeof reducer>[1];
export default reducer;
